import React from 'react';
import { alpha } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { PhotoOutlined as PhotoOutlinedIcon } from '@mui/icons-material';

interface ImagePlaceholderProps {
  title: string;
  subtitle?: string;
  minHeight?: number | string;
}

export default function ImagePlaceholder({
  title,
  subtitle = 'Място за снимка или илюстрация',
  minHeight = 180,
}: ImagePlaceholderProps) {
  return (
    <Box
      data-testid="image-placeholder"
      sx={{
        minHeight,
        borderRadius: 4,
        border: '1px dashed',
        borderColor: alpha('#cbd5e1', 0.28),
        background: `linear-gradient(135deg, ${alpha('#7dd3fc', 0.12)} 0%, ${alpha('#8bffb0', 0.08)} 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        textAlign: 'center',
      }}
    >
      <Box>
        <PhotoOutlinedIcon sx={{ fontSize: 32, color: 'primary.main', mb: 1 }} />
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
}
